import siteData from '../siteData.json';
import { useScrollContext }  from '../providers/ScrollProvider';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { FaEnvelope, FaPhone } from 'react-icons/fa6';
import Reveal from './Reveal';

function Topbar() {
  const { scrolled } = useScrollContext();

  const options = {
    address: <><FaMapMarkerAlt className="icon address" /><p>{siteData.location.address}</p></>,
    phone: <><FaPhone className="icon phone" /><p>{siteData.contactInfo.phoneNumber}</p></>,
    email: <><FaEnvelope className="icon email" /><p>{siteData.contactInfo.email}</p></>
  };

  return (
    <div className={`topbar ${scrolled && 'scrolled'}`}>
      <Reveal direction="right" order={0} className="left">
        {options[siteData.topbar.left]}
      </Reveal>
      <Reveal direction="left" order={0} className="right">
        {options[siteData.topbar.right]}
      </Reveal>
    </div>
  )
}

export default Topbar;